import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
// import reportWebVitals from './reportWebVitals'
import App from './App'
import { MySmartflowContext } from '@context/my-smartflow.context'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from './lib/react-query'

import './index.scss'

const rootElement = document.getElementById('root')

if (!rootElement) throw new Error('Failed to find the root element')

const root = createRoot(rootElement)

root.render(
  <StrictMode>
    <MySmartflowContext>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </MySmartflowContext>
  </StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log)
